<template>
    <div class="w-full">
        <component
            v-if="select"
            :is="dialog.comp1"
            v-bind="{ ...dialog.props1 }"
            v-model="picker"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :value="value ? value : null"
                    :label="label"
                    :prepend-inner-icon="icon"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    :hide-details="hideDetails"
                    :error-messages="error"
                    :rules="rules"
                    :clearable="clearable"
                    @click:clear="$emit('clear')"
                    :loading="loading"
                    :disabled="disabled"
                ></v-text-field>
            </template>
            <v-date-picker
                ref="menuDate"
                :type="type"
                next-icon="chevron_right"
                prev-icon="chevron_left"
                class="soli-round"
                v-model="selected"
                :active-picker.sync="activePicker"
                :events="events"
                :min="birthday ? '1900-01-01' : min ? min : tomorrow"
                :max="
                    birthday
                        ? globalMomentISO(new Date())
                        : max
                        ? max
                        : noLimit
                        ? null
                        : twoWeeks
                "
                :full-width="$vuetify.breakpoint.smAndDown"
                :allowed-dates="birthday ? null : allowedDates"
                :no-title="noTitle"
                :eventColor="eventColor"
                @input="picker = false"
                @change="birthday ? saveBirthday : null"
                @click:year="saveYear"
            ></v-date-picker>
        </component>

        <v-skeleton-loader
            class="mx-auto"
            max-width="300"
            type="list-item, list-item, list-item"
            v-if="loading && !select"
        ></v-skeleton-loader>

        <v-date-picker
            next-icon="chevron_right"
            prev-icon="chevron_left"
            class="soli-round"
            :type="type"
            :active-picker.sync="activePicker"
            style="border: none !important"
            full-width
            v-if="!select && !loading"
            v-model="selected"
            no-title
            :events="events"
            :allowed-dates="birthday ? null : allowedDates"
            :eventColor="eventColor"
            :min="birthday ? '1900-01-01' : min ? min : tomorrow"
            :max="
                birthday
                    ? globalMomentISO(new Date())
                    : max
                    ? max
                    : noLimit
                    ? null
                    : future
                    ? sixWeeks
                    : twoWeeks
            "
            @input="picker = false"
            @change="birthday ? saveBirthday : null"
        ></v-date-picker>
    </div>
</template>

<script>
import { VMenu, VBottomSheet } from "vuetify/lib";
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    name: "SoliDate",
    mixins: [globalMoment],
    components: {
        VMenu,
        VBottomSheet,
    },
    data: function () {
        return {
            picker: null,
            activePicker: null,
        };
    },
    props: {
        label: {
            type: String,
            default: "Date",
        },
        value: {
            type: String,
            default: "",
        },
        error: {
            type: String,
            default: "",
        },
        rules: {
            type: Array,
            default: null,
        },
        icon: {
            type: String,
            default: "today",
        },
        events: {
            type: Array,
            default: null,
        },
        eventColor: {
            type: String,
            default: "secondary",
        },
        reschedule: {
            type: Boolean,
            default: false,
        },
        select: {
            type: Boolean,
            default: true,
        },
        birthday: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        future: {
            type: Boolean,
            default: false,
        },
        min: {
            type: String,
            default: null,
        },
        max: {
            type: String,
            default: null,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "date",
        },
        noLimit: {
            type: Boolean,
            default: false,
        },
        noTitle: {
            type: Boolean,
            default: false,
        },
        yearOnly: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        dialog() {
            return {
                comp1: this.$vuetify.breakpoint.smAndDown
                    ? "v-bottom-sheet"
                    : "v-menu",
                props1: {
                    "close-on-content-click": false,
                    "nudge-right": "-12",
                    "nudge-bottom": "12",
                    "max-width": "450",
                    "offset-y": true,
                    "min-width": "290",
                    ref: "menu",
                },
            };
        },
        selected: {
            get() {
                let substr = this.type == "month" ? 7 : this.yearOnly ? 4 : 10;
                return this.value
                    ? new Date(this.value).toISOString().substr(0, substr)
                    : new Date().toISOString().substr(0, 10);
            },
            set(value) {
                this.$emit("input", this.globalMomentUTCDate(value));
            },
        },
        tomorrow() {
            if (this.future && this.$page.component == "Store") {
                return moment(new Date()).startOf("month").format("YYYY-MM-DD");
            }
            if (
                this.can("Schedule within 24 hours") &&
                this.$page.props.staffView
            ) {
                return null;
            }
            return this.reschedule || this.future
                ? moment().add(24, "hours").toISOString(true)
                : null;
        },
        twoWeeks() {
            return moment().add(2, "weeks").toISOString(true);
        },
        month() {
            return this.future
                ? moment().add(1, "months").toISOString(true)
                : null;
        },
        sixWeeks() {
            return moment().add(6, "weeks").toISOString(true);
        },
    },
    methods: {
        allowedDates(val) {
            if (this.events) {
                if (this.$page.component == "Exit") return val;
                if (!this.events.length) return;
            }
            if (this.future && this.$page.component == "Store") {
                return val <= this.max;
            }
            if (this.future && this.noLimit) {
                return val > this.globalMomentISO(new Date());
            }
            if (this.$page.component == "Reports/FinanceEntry") {
                return !this.events.includes(val);
            }
            if (this.$page.component == "Reports/StudioHealth") {
                return val;
            }
            if (
                this.$page.props.staffView &&
                this.$page.component == "ShowUser"
            ) {
                return val;
            }
            if (
                this.$page.props.staffView &&
                this.$page.component == "Reports/TimeClock"
            ) {
                return val;
            }

            /*return this.type == "Weekly Lesson" || this.reschedule
        ? this.events.includes(val)
        : val;*/
            return this.events.includes(val);
        },
        saveBirthday(birthday) {
            this.$refs.menu.save(birthday);
        },
        saveYear(year) {
            if (!this.yearOnly) return;
            let date = new Date(new Date().setFullYear(year));
            this.$refs.menu.save(date);
            this.$refs.menuDate.$emit("input", date);
        },
    },
    mounted() {
        this.$emit("mounted");
    },
    watch: {
        picker(val) {
            if (this.birthday) {
                val && setTimeout(() => (this.activePicker = "YEAR"));
            }
            if (this.yearOnly) {
                val;
                val && this.$nextTick(() => (this.activePicker = "YEAR"));
            }
            if (!val) this.$emit("blurDate");
        },
    },
};
</script>
